import React from 'react';
import { Accordion } from 'react-bootstrap';

function HelpGuide() {
  return (
    <Accordion className="mb-3">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Help on using this system</Accordion.Header>
        <Accordion.Body>
          <p>Search the original 1955 printing of The Urantia Papers…fast!</p>
          <h5>Basic Search</h5>
          <ul>
            <li>Type words separated by spaces to find paragraphs containing all those words in any order. Example: <i>cosmic whole</i> finds paragraphs with both of these words in them in any order and not necessarily adjacent to one another.</li>
            <li>Automatically expands to include common word variants and common alternate spellings. Example: <i>adjust</i> also searches for paragraphs that contain any of <i>adjusts, adjusted, adjusted, adjusting,</i> and more.</li>
            <li>Don't want variants? Use an <i>"exact" "search"</i> or change settings to another search mode.</li>
          </ul>
          <h5>+Wildcard Search+</h5> 
          <ul>
            <li>Starts with: <i>cosm+</i> finds words starting with this, such as <i>cosmic, cosmology, cosmopolitan,</i> and more.</li>
            <li>Ends with: <i>+dek</i> finds all words ending with "dek", such as Vorondadek, Lanonandek, and Melchizedek.</li>
            <li>Contains: <i>+gravity+</i> finds all words containing "gravity" such as "gravitational" and "antigravity". </li>
            <li>Wildcards cannot be used within an "exact search".</li>
          </ul>
          <h5>"Exact Search"</h5>
          <ul>
            <li>Quote marks indicate exact phrase matching. Example: <i>"in a cosmic system"</i> finds the one occurrence of that phrase among all of the papers.</li>
            <li>To match exact single words without variants, place the word in quotes. Example: <i>"adjust"</i> finds paragraphs with that word in them but no variants like <i>adjusted or adjuster</i>.</li>
          </ul>
          <h5>Notes</h5>
          <ul>
            <li>Searches are not case sensitive. Example: <i>deity</i> and <i>Deity</i> find the same results even though capitalization changes the meaning of this word.</li>
            <li>Combine as many basic, exact, and wildcard searches as you want in a single search.</li>
            <li>Results are limited to the first 1,000 hits. If you need more, try a different search.</li>
          </ul>
          <h5>Original 1955 Printing?</h5>
          <p>
            This system has been programmed with an exact digitization of <em>the original 1955 printing</em>. Typographical errors and spelling inconsistencies
            are compensated for by the basic search feature (not an "exact" "search"). What does that mean? Well, 
            since first being published in 1955, people have published editions of The Urantia Papers that various changes and corrections.
            The <i>Standard Reference Text</i> is one such edition. But it includes changes Symmetry of Soul does not agree with, so we play it safe:
            use the original 1955 printing and program our search system to accommodate typos and spelling inconsistencies.
          </p>
          <h5>Potential Future Ideas</h5>
          <ul>
            <li>Sequential search: <i>cosmic...system</i> would find paragraphs containing where "cosmic" (or its variants) is then followed by "system" with any number of words intervening. It would not match on the word system followed by cosmic. This might be useful for finding common turns of phrase you cannot quite remember.</li>
            <li>Search a block of text: including a search term of the form <i>[195], [195:8], [195:8:10]</i> will search only within the specified paper, section, or paragraph. Search for this by itself to simply return the text for that paper, section, or paragraph.</li>
            <li>Search a range of text: adding a hyphen will indicte a range of text to search (or display if this search term is used alone). Example: searching <i>[120-196]</i> will limit searches to only Part IV; <i>[14:2-16:8], [16:6.1-7]</i> are also valid searches.</li>
          </ul>
          <cite>Copyright © 2025 <a href="https://symmetryofsoul.org">Symmetry of Soul ministries</a>. All rights reserved.</cite>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default HelpGuide; 